'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context,
        timeDrag = false,
        // dragging playhead three variables shared between all AudioBlocks
    $timeAudioPlayer,
        $timeAudioBlock;

    function playPauseFn($audioBlock, $player) {
        if ($audioBlock.hasClass('playing') === false) {
            $player.play();
            $audioBlock.addClass('playing');
        } else {
            $player.pause();
            $audioBlock.removeClass('playing');
        }
    }

    function timeUpdate(e) {
        var $audioPlayer = e.target;
        var $audioBlock = $(e.target).closest('[data-binding="audio-block-source"]');
        var playPercent = 100 * ($audioPlayer.currentTime / $audioPlayer.duration);

        $audioBlock.find('[data-binding="audio-scrubber"]').css('left', playPercent + '%');
        $audioBlock.find('[data-binding="audio-progressbar"]').css('width', playPercent + '%');
    }

    function updatebar(pageX) {
        var progress = $timeAudioBlock.find('[data-binding="audio-playbar"]');
        var maxduration = $timeAudioPlayer.duration; //Video duraiton
        var position = pageX - progress.offset().left; //Click pos
        var percentage = 100 * position / progress.width();

        //Check within range
        if (percentage > 100) {
            percentage = 100;
        }
        if (percentage < 0) {
            percentage = 0;
        }

        $timeAudioPlayer.currentTime = maxduration * percentage / 100;
    }

    function checkKey(e) {
        e = e || window.event;
        return e.keyCode;
    }

    function init() {
        var playPause = '<button class="audio-block__playpause" data-binding="audio-playpause"></button>',
            playBar = '<div class="audio-block__playbar" data-binding="audio-playbar"><div class="audio-block__progressbar" data-binding="audio-progressbar"></div><button data-binding="audio-scrubber" class="audio-block__playbar__scrubber"></button></div>',
            jsPlayer = '<div class="audio-block__jsplayer">' + playPause + playBar + '</div>';

        // iterate over each audio block on the page
        context.each(function () {
            var $this = $(this);
            var $audioBlock = $this.find('[data-binding="audio-block-source"]'),
                $audioPlayer = $audioBlock.find('[data-binding="audio-element"]')[0];

            // add replacement JS player
            $audioBlock.append(jsPlayer);

            // play/pause on click
            $audioBlock.on('click', '[data-binding="audio-playpause"]', function (e) {
                e.preventDefault();
                playPauseFn($audioBlock, $audioPlayer);
            });

            // listens for any time the time is updated and runs function to move playhead
            $audioPlayer.addEventListener('timeupdate', timeUpdate, false);

            //listens for when the track ends
            $audioPlayer.addEventListener('ended', function () {
                $audioBlock.removeClass('playing');
            }, false);

            // update player time on playbar click
            $audioBlock.on('click', '[data-binding="audio-playbar"]', function (e) {
                var $this = $(this),
                    offset = $this.offset(),
                    timelineWidth = $this.width(),
                    clickpos = (e.clientX - offset.left) / timelineWidth * 100,
                    newTime;

                newTime = $audioPlayer.duration * clickpos / 100;

                $audioPlayer.currentTime = newTime;
            });

            $('[data-binding="audio-scrubber"]').mousedown(function (e) {
                // because there can be only one active playhead scrubbing use module global variables
                timeDrag = true;
                $timeAudioBlock = $(e.target).closest('[data-binding="audio-block-source"]');
                $timeAudioPlayer = $timeAudioBlock.find('[data-binding="audio-element"]')[0];
                updatebar(e.pageX);
            });
            $(document).mouseup(function (e) {
                if (timeDrag) {
                    updatebar(e.pageX);
                    timeDrag = false;
                    $timeAudioPlayer = $timeAudioBlock = null;
                }
            });
            $(document).mousemove(function (e) {
                if (timeDrag) {
                    updatebar(e.pageX);
                }
            });

            // keyboard support for timeline scrubber
            $audioBlock.find('[data-binding="audio-playbar"]').on('keydown', 'button', function () {
                var code = checkKey(),
                    currentPos = $audioPlayer.currentTime,
                    maxPos = $audioPlayer.duration,
                    newPos = currentPos;

                if (code === 37) {
                    //left
                    if (currentPos > 0) {
                        newPos = currentPos - 1;
                    }
                } else if (code === 39) {
                    //right
                    if (currentPos < maxPos) {
                        newPos = currentPos + 1;
                    }
                }
                $audioPlayer.currentTime = newPos;
            });
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/audio-player.js
// module id = 105
// module chunks = 0